
import { get } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'

import type { AccTemplate } from '../account_template/types'
import { account_templates_store } from './account_templates'
import type { AccTemplates } from './types'


let promiseFetch: Promise<AccTemplates | null>
let state: 'pending' | 'reading' | 'ready' = 'pending'


export const InitAccountTemplates = async (pFetch = fetch, force = false) => {
	// if SSR just return the promise data
	if (!browser) return fetchData(pFetch)

	if (!force && state === 'ready') return promiseFetch
	if (!force && state === 'reading') {
		return promiseFetch
	}

	promiseFetch = fetchData(pFetch)
	return promiseFetch
	
}

const fetchData = async (pFetch = fetch) => {
	if (browser) state = 'reading'

	const theUrl = '/account_templates'
	const jsonData = await apiFetchJson(pFetch, 'get', theUrl)

	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return null
	}

	// const data = parseAccountTemplates(jsonData.account_templates)
	const data = jsonData.account_templates
	if (browser) {
		account_templates_store.set(data)
		state = 'ready'
	}

	return data
}


export function IsCustomColor(color: string) {

	const templates = get(account_templates_store)
	if (templates.length === 0) {
		if (color === '#116001') return false
		return true
	}

	const matchingTemplate = templates.find((accTemplate) => {
		return accTemplate.user_config?.style?.mainAccentColor === color
	})
	
	let result = false
	if (!matchingTemplate) result = true

	return result
}

export function upsertAccTemplate(newTemplate: AccTemplate): AccTemplates {

	let acc_templates = get(account_templates_store)
	const existingTemplateIndex = acc_templates.findIndex(template => template.id === newTemplate.id)
  
	if (existingTemplateIndex !== -1) {
	  // Update existing template
	  acc_templates[existingTemplateIndex] = {
			...acc_templates[existingTemplateIndex],
			user_config: newTemplate.user_config,
	  }
	} else {
	  // Add new template
	  acc_templates = [...acc_templates, newTemplate]
	}
	account_templates_store.set(acc_templates)
	return acc_templates
}

// function parseAccountTemplates(source: ServerAccountTemplates): AccountTemplates {
// 	return {
// 		...source,
// 		invoice_receipt_date: parseGoDate(source.invoice_receipt_date),
// 		total: Big(source.total)
// 	}
// }


// export async function UpdAccTemplateConfig (acc_template: AccTemplate) {
// 	const url = `/account_templates/config/${acc_template.doc_type}/${acc_template.template_id}`
// 	apiPostJson(url, { config: acc_template.user_config })
// 	account_templates_store.update(templates => {
// 		const updatedItems = templates.map(template => {
// 			if (template.id === acc_template.id) {
// 				return { ...template, user_config: acc_template.user_config }
// 			}
// 			return template
// 		})
// 		return updatedItems
// 	})
// }
